import React from 'react';
import { Vector3 } from 'three';
import Arrow from './Arrow';


function DimensionLine({inPo1, inPo2}) {

    const start = new Vector3(inPo1[0], inPo1[1], inPo1[2]);
    const end = new Vector3(inPo2[0], inPo2[1], inPo2[2]);

    const midPoint = new Vector3().addVectors(start, end).divideScalar(2);
    const dir1 = new Vector3().subVectors(end, midPoint).normalize();
    const dir2 = new Vector3().subVectors(start, midPoint).normalize();

    const color = 'grey';
    const length = start.distanceTo(end) / 2;

    return (
        <>
            <Arrow origin={midPoint} dir={dir1} length={length} color={color} />
            <Arrow origin={midPoint} dir={dir2} length={length} color={color} />
        </>
    );
}
export default DimensionLine;